import { Component, Prop, mixins } from 'nuxt-property-decorator';
import { TranslateResult } from '../../../../types/i18n';
import InputValidationMixin from '../InputValidationMixin';
import { v4 as uuid } from 'uuid';

@Component
export default class InputTextMixin extends mixins(InputValidationMixin) {
  @Prop({ default: '' }) readonly label!: string | TranslateResult;
  @Prop({ default: null }) readonly validation!: object | string | null;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean;
  @Prop({ type: String }) readonly autocomplete!: string;
  @Prop({ type: String }) readonly placeHolder!: string | TranslateResult;
  @Prop({ type: Number }) readonly maxLength!: number;
  @Prop({ type: String }) readonly help!: string | TranslateResult;
  @Prop({ type: String }) readonly hint!: string | TranslateResult;

  get inputId() {
    return this.name ? this.name : uuid();
  }
}
